export enum FieldsMapLabels {
    field = 1,
    crop = 2,
    variety = 4
}
